var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "l-bg-white" }, [
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            },
            keydown: function($event) {
              _vm.clearError($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-3 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Created at")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { class: { disabled: !_vm.$_can("job-charges.update") } },
                    [_vm._v(_vm._s(_vm.transaction.date))]
                  )
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "created_at" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3 px-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Ref id")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { class: { disabled: !_vm.$_can("job-charges.update") } },
                    [_vm._v("#" + _vm._s(_vm.transaction.ref_id))]
                  )
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "ref_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3 pl-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Customer")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { class: { disabled: !_vm.$_can("job-charges.update") } },
                    [
                      _vm.transaction.customer
                        ? [
                            _vm._v(
                              _vm._s(_vm.transaction.customer.first_name) +
                                " " +
                                _vm._s(_vm.transaction.customer.last_name)
                            )
                          ]
                        : _c("span", { staticClass: "text-danger" }, [
                            _vm._v("Deleted customer")
                          ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "customer" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-3 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Amount in $")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.transaction.amount,
                        expression: "transaction.amount"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      disabled: !_vm.$_can("job-charges.update")
                    },
                    domProps: { value: _vm.transaction.amount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.transaction, "amount", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "amount" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3 px-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Payment Method")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        id: "payment",
                        options: _vm.listPaymentMethods,
                        placeholder: "Select Payment Methods",
                        disabled:
                          !_vm.$_can("job-charges.update") ||
                          _vm.transaction.payment_method_id === 4
                      },
                      on: { input: _vm.listPaymentMethods },
                      model: {
                        value: _vm.transaction.payment_method_id,
                        callback: function($$v) {
                          _vm.$set(_vm.transaction, "payment_method_id", $$v)
                        },
                        expression: "transaction.payment_method_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "type" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3 pl-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Payment type")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        id: "payment-type",
                        options: _vm.paymentTypes,
                        placeholder: "Select Payment Types",
                        disabled: !_vm.$_can("job-charges.update")
                      },
                      on: { input: _vm.paymentTypes },
                      model: {
                        value: _vm.transaction.payment_type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.transaction, "payment_type_id", $$v)
                        },
                        expression: "transaction.payment_type_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "payment_type" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Note")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.transaction.note,
                        expression: "transaction.note"
                      }
                    ],
                    staticClass: "form-control select-wrap-textarea",
                    attrs: {
                      cols: "30",
                      rows: "5",
                      disabled: !_vm.$_can("job-charges.update")
                    },
                    domProps: { value: _vm.transaction.note },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.transaction, "note", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "note" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.$_can("job-charges.update") || _vm.$_can("job-charges.destroy")
            ? _c("div", { staticClass: "row mt-5" }, [
                _vm.transaction.payment_method_id !== 4 &&
                _vm.$_can("job-charges.destroy")
                  ? _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.remove(_vm.transaction.id)
                              }
                            }
                          },
                          [_vm._v("\n            Delete\n          ")]
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "charge" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$_can("job-charges.update")
                  ? _c("div", { staticClass: "col" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary float-right ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: { disabled: _vm.buttonDisabled }
                        },
                        [
                          _vm._v("\n            Save\n            "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h1", [_vm._v("Edit Transactions")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a8bab8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8bab8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transactions/TransactionsEdit.vue
// module id = null
// module chunks = 